import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PoProcessingComponent} from './po-processing.component';

const routes: Routes = [{path: '', component: PoProcessingComponent}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PoProcessingRoutingModule {
}
